<unity-page-container contentHeader="User Management" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createUserAction" />
    <unity-action-shared [action]="createInternalUserAction" />
  </ng-container>

  <unity-grid-user-internal-shared />
</unity-page-container>
